import { StrictMode } from "react";
import AuthProvider from "./components/Auth/AuthProvider";
import { ThemeProvider } from "@mui/material";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { routes } from "./components/Navigation/routes/routes";
import { GetLanguage } from "./helpers/getLanguage";
import CustomNotifications from "../src/components/Notifications/CustomNotifications";
import { ColorPalette } from "./Themes/index";

function App() {
  const noaTheme = useTheme(ColorPalette());

  const router = createBrowserRouter(routes);

  GetLanguage();

  return (
    <StrictMode>
      <AuthProvider>
        <ThemeProvider theme={noaTheme}>
          <CustomNotifications>
            <RouterProvider router={router} />
          </CustomNotifications>
        </ThemeProvider>
      </AuthProvider>
    </StrictMode>
  );
}

export default App;
